<template>
  <div>
    <ListingLayout
      :is-loading="isLoading"
      :meta="meta"
      :headers="_headers"
      :items="list"
      :product-options="productOptions"
      search-label="search"
      vertical-scroll
      :filter-names="filterNames"
      @filterOption="onFiltersChange"
    >
      <template v-slot:name="{ item }">
        <div class="text-capitalize">
          {{ item.name }}
        </div>
      </template>
      <template v-slot:type="{ item }">
        <div class="text-capitalize">
          {{ item.type }}
        </div>
      </template>

     
      <template v-slot:fuel_rate="{ item }">
        <div class="text-capitalize">
          {{ item.currency }}-{{ item.fuel_rate }}
        </div>
      </template>
      
      <template v-slot:actions="{ item }">
        <v-icon
          v-if="isEdit"
          class="mr-2"
          small
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          v-if="isDelete"
          class="mr-2"
          small
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>
      <template #addFilters>
        <v-card>
          <v-autocomplete
            v-model="customFilters.fuel_type"
            filled
            dense
            clearable
            :items="fuelTypeList"
            item-value="id"
            item-text="name"
            :label="$t('fuel_type')"
            @change="fetchData"
          />
        </v-card>
      </template>

      <!-- Action Modals -->
      <template #actionModals>
        <div class="d-flex">
          <create-modal
            v-if="isCreate"
            :filter-options="options"
          />
          <edit-modal
            v-if="(isView || isEdit) && editModal"
            :is-visible-dialog="editModal"
            :toggle-edit="toggleEditModal"
            :item="selectedRow"
          />
          <confirmation-modal
            v-if="isDelete"
            :is-visible="deleteModal"
            :toggle="toggleDeleteModal"
            :row="selectedRow"
          />
        </div>
      </template>
      <!-- Action Modals -->
    </ListingLayout>
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { mapGetters } from "vuex";
// import { debounce } from "lodash";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    CreateModal: () => import("./dialogs/CreateFuel.vue"),
    EditModal: () => import("./dialogs/EditFuel.vue"),
    ConfirmationModal: () =>
      import("@/components/Modals/ConfirmationModal.vue"),
  },
  mixins: [ListingLayoutMixins],

  data() {
    return {
      permissions: {
        view: "fuel-prices.view",
        create: "fuel-prices.create",
        edit: "fuel-prices.edit",
        delete: "fuel-prices.delete",
      },
      productOptions: [
        { id: "oem", value: "OEM" },
        { id: "fleet", value: "Fleet" },
        { id: "dispenser", value: "Dispenser" },

      ],
      filters: {},
      subFilters: {},

      // 
      customFilters:{}
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "fuelPrices/getLoading",
      meta: "fuelPrices/getMeta",
      list: "fuelPrices/getList",
      fuelTypeList: "fuelPrices/getFuelType"
    }),
    filterNames() {
      return [];
    },
    _headers() {
      const headers = [
        {
          text: this.$t("id"),
          align: "left",
          sortable: true,
          value: "id",
        },
       
        {
          text: this.$t("tenant_name"),
          align: "left",
          sortable: false,
          value: "tenant_name",
          showAdmin: true,
        },
        
        {
          text: this.$t("type"),
          align: "left",
          sortable: false,
          value: "type",
        },
        
        {
          text: this.$t("fuel_rate"),
          align: "left",
          sortable: false,
          value: "fuel_rate",
        },
       
         {
          text: this.$t("date"),
          align: "left",
          sortable: false,
          value: "date",
        },
        ...(this.isView || this.isEdit || this.isDelete
          ? [
            {
              text: this.$t("actions"),
              align: "left",
              sortable: false,
              value: "actions",
            },
          ]
          : []),
      ];
      // computed headers for showing columns to role based
      return headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },

  },
  watch: {
    // "options.fleetId": {
    //   handler: function (val) {
    //     if (this.isMounted) {
    //       this.terminal_id = "";
    //     }
    //     this.isMounted = true;
    //     if (val) {
    //       const params = { tenant_id: val };
    //       this.$store.dispatch("terminal/dropDownList", params);
    //     } else {
    //       this.$store.commit("terminal/SET_LIST_DROPDOWN", []);
    //     }
    //   },
    // },
    // "options.tenant_id": {
    //   handler: function (val) {
    //     if (this.isMounted) {
    //       this.terminal_id = "";
    //     }
    //     this.isMounted = true;
    //     if (val) {
    //       const params = { tenant_id: val };
    //       this.$store.dispatch("terminal/dropDownList", params);
    //     } else {
    //       this.$store.commit("terminal/SET_LIST_DROPDOWN", []);
    //     }
    //   },
    // },
    options() {
      this.fetchData();
    },
  },
  async mounted() {
    this.$store.dispatch('fuelPrices/fuelType')
    // if (!this.authUser.isAdmin) {
    //   const params = { tenant_id: this.authUser.tenant_id };
    //   await this.$store.dispatch("terminal/dropDownList", params);
    // }
    if (this.$route?.query?.fuel_type) {
      this.fuel_type = this.$route.query.fuel_type;
    }
    
  },

  beforeDestroy() {
    const paramsset = { ...this.options, ...this.customFilters};
    const params = {
      name: "fuel_prices",
      filters: paramsset,
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  methods: {

    async fetchData() {
      
      const params = {...this.options, ...this.customFilters}
      await this.$store
        .dispatch("fuelPrices/list", params)
        .then(() => {
          if (this.options.page > (this.meta?.lastPage || 1)) {
            this.options.page = 1;
          }
        });
    },

    // Confirmation of Delete Row
    async deleteSelectedRow(row) {
      try {
        await this.$store.dispatch("fuelPrices/destroy", row);
        this.$store.dispatch("alerts/success", this.$t("deleted_successfully"));
        if (this.list.length === 0 && this.meta.lastPage == this.options.page) {
          this.options.page -= 1; // Move to the previous page
        }
        this.toggleDeleteModal("close");
        this.fetchData();
      } catch (error) {
        this.$store.dispatch("alerts/error", error.response?.data?.message);
      }
    },
    //
    
  },
};
</script>
<style lang="sass" scoped>
.map-button
  height: 41px !important
  margin-right: 5px

.btn-disabled
  pointer-events: none !important
  background-color: #8f8f8f !important

:deep .v-autocomplete.v-text-field--enclosed:not(.v-text-field--solo):not(.v-text-field--single-line):not(.v-text-field--outlined).v-input--dense .v-select__slot > input
  font-size: 0.875rem !important
</style>